export default __webpack_public_path__ + "static/media/arrows-move-gestalt.83d906b4.svg";